function changeFilter({ input, state }) {
  let path = 'users.searchOptions.filters'
  let filters = state.get(path)
  let index = filters.reduce((acc, filter, currentIndex) => {
    if (filter === input.filter) {
      acc = currentIndex
    }
    return acc
  }, -1)
  if (input.selected) {
    state.splice(path, index, 1)
  } else {
    state.push(path, input.filter)
  }
}

export default changeFilter



// WEBPACK FOOTER //
// ./src/modules/user/actions/changeFilter.js